import {
  Button,
  ModalComponentWrapper,
  ResultContent,
} from '@/shared/components';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/utils';

interface ResultModalProps {
  success: boolean;
  onClose: () => void;
  error?: Error;
}

export function ResultModal({ success, onClose, error }: ResultModalProps) {
  const { t } = useTranslation();

  const resultTitle = t(
    success
      ? 'depositMethods.creditCard.result.successTitle'
      : 'depositMethods.creditCard.result.errorTitle'
  );
  const resultDescription = t(
    success
      ? 'depositMethods.creditCard.result.successDescription'
      : error?.message
        ? error.message
        : 'depositMethods.creditCard.result.errorDescription'
  );
  const resultButtonText = t(
    success
      ? 'depositMethods.creditCard.result.successButton'
      : 'depositMethods.creditCard.result.errorButton'
  );

  return (
    <ModalComponentWrapper
      footer={
        <Button
          type="submit"
          variant="default"
          size="lg"
          onClick={onClose}
          className={cn('w-full')}>
          {resultButtonText}
        </Button>
      }>
      <ResultContent
        className="h-auto"
        isSuccess={success}
        showButton={false}
        title={resultTitle}
        description={resultDescription}></ResultContent>
    </ModalComponentWrapper>
  );
}
